import React from 'react';

import BannerBlock from './Banner';
import TextBlock from './Text/Text';
import TwoColumnImageBlock from './TwoColumnImage/TwoColumnImage';
import UspBlock from './UspBlock';
import QuoteLoopBlock from './QuoteLoop';
import PricingGridBlock from './PricingGrid';
import MindBodyWidgetBlock from './MindBodyWidget/MindBodyWidget';
import MindBodyBrandedWebWidgetBlock from './MindBodyWidget/MindBodyBrandedWebWidget';
import TwoColumnBlock from './TwoColumn';
import SmallBannerBlock from './SmallBanner';
import CardsSliderBlock from './CardsSlider';
import CardsBlock from './Cards';
import ImageSliderBlock from './ImageSlider';
import VideoBlock from './Video';
import AccordionBlock from './Accordion';
import CalendlyWidgetBlock from './CalendlyWidget';
import BsportCalendarWidgetBlock from './BsportCalendarWidget';
import BsportPassesWidgetBlock from './BsportPassesWidget';
import BsportAppointmentsWidgetBlock from './BsportAppointmentsWidget';

const renderBlock = block => {
  switch (block.typeHandle) {
    case 'banner':
      return <BannerBlock key={block.id} block={block} />;
    case 'text':
      return <TextBlock key={block.id} block={block} />;
    case 'twoColumnImage':
      return <TwoColumnImageBlock key={block.id} block={block} />;
    case 'usps':
      return <UspBlock key={block.id} block={block} />;
    case 'quoteLoop':
      return <QuoteLoopBlock key={block.id} block={block} />;
    case 'pricingCards':
      return <PricingGridBlock key={block.id} block={block} />;
    case 'mindbodyWidget':
      return <MindBodyWidgetBlock key={block.id} block={block} />;
    case 'MindBodyBrandedWebWidget':
      return <MindBodyBrandedWebWidgetBlock key={block.id} block={block} />;
    case 'twoColumn':
      return <TwoColumnBlock key={block.id} block={block} />;
    case 'smallBanner':
      return <SmallBannerBlock key={block.id} block={block} />;
    case 'cardsSlider':
      return <CardsSliderBlock key={block.id} block={block} />;
    case 'twoCards':
      return <CardsBlock key={block.id} block={block} />;
    case 'imageSlider':
      return <ImageSliderBlock key={block.id} block={block} />;
    case 'video':
      return <VideoBlock key={block.id} block={block} />;
    case 'accordion':
      return <AccordionBlock key={block.id} block={block} />;
    case 'calendlyWidget':
      return <CalendlyWidgetBlock key={block.id} block={block} />;
    case 'bsportCalendarWidget':
      return <BsportCalendarWidgetBlock key={block.id} block={block} />;
    case 'bsportPassesWidget':
      return <BsportPassesWidgetBlock key={block.id} block={block} />;
    case 'bsportAppointmentsWidget':
      return <BsportAppointmentsWidgetBlock key={block.id} block={block} />;
    default:
      break;
  }
};

const Blocks = ({ blocks }) => <>{blocks.map(block => renderBlock(block))}</>;

export default Blocks;
